export default {
  suspiciousType: '异常类型',
  plant: '仓库',
  nfcUid: 'NFC UID',
  operationDate: '操作日期',
  operation: '操作',
  blockReason: '拦截原因',
  printNfcId: '请输入 NFC UID',
  warningContent: '时间范围不能超过31天，请重新选择时间。'
}
